'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".Backdrop-module_backdropContainer__8-jYt{align-items:center;background-color:hsla(0,0%,100%,.5);display:flex;flex-direction:column;justify-content:center;position:fixed}";
var styles = {"backdropContainer":"Backdrop-module_backdropContainer__8-jYt"};
styleInject["default"](css_248z, '73fedae9-7054-4974-a3f6-337edd132c45');

exports["default"] = styles;
